import produce from 'immer';

import {
  getDeadLetterDatasetOriginalId,
  getType,
  upstreamPipeIsGlobal,
} from '../internals/datasets';

import type { SomeObject } from '../types/common.types';
import type { Dataset } from '../types/dataset.types';
import type { PipeMap } from '../types/pipes.types';
import type { Upstreams } from '../types/state.types';

const isInternalDatasetRegex = /^(system:|configure_node:|load_nodeconfig:|merge_nodeconfig:)/;

export function decorateDataset(rawDataset: SomeObject): Dataset {
  return <Dataset>produce(rawDataset, (dataset) => {
    const id = dataset._id;
    dataset.link = encodeURIComponent(id);
    dataset.origin = dataset.runtime.origin;
    if (dataset.origin == null) {
      dataset.origin = isInternalDatasetRegex.test(id) ? 'system' : 'user';
    }
    dataset.isInternal = dataset.origin !== 'user';
    dataset.state = dataset.runtime.populated ? 'populated' : 'not populated';
    if (getType(dataset._id) === 'dead_letter_dataset') {
      dataset.originalDataset = getDeadLetterDatasetOriginalId(dataset._id);
    }
  });
}

export const getDatasetsWithGlobal = (
  datasets: Dataset[],
  pipes: PipeMap,
  upstreams: Upstreams
) => {
  return datasets.map((dataset) => {
    const datasetCopy = { ...dataset };

    datasetCopy['_global'] = upstreamPipeIsGlobal(datasetCopy._id, pipes, upstreams) ? 'Yes' : 'No';

    return datasetCopy;
  });
};
